import React, {useContext} from 'react';
import {ControlledFormContext} from "../ControlledForm";
import {Utils} from "../../../logic/reusable/Utils";

function TextInput(props: TextInputProps) {
    const {name, label, labelAbove, multiLine} = props
    const {formData, handleFormChange} = useContext(ControlledFormContext)

    return (
        <div className={`atoms-inputs-text ${labelAbove ? "above" : ""}`}>
            {label ? <label htmlFor={name}>{label}</label> : null}
            {
                multiLine ? <textarea className={label ? "no-label" : ""} name={name} value={Utils.dynamicKeyAccess(formData, name)} onChange={handleFormChange}/> :
                    <input className={label ? "" : "no-label"} name={name} type="text" value={Utils.dynamicKeyAccess(formData, name)} onChange={handleFormChange}/>
            }
        </div>
    );
}

export default TextInput;
